// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"341":"8d6c96b6","447":"4775c059","583":"59d3937a","954":"95dfa4ed"}[chunkId] + ".chunk.css";
};